// extracted by mini-css-extract-plugin
export default {"link":"NormalLink_link__jM1cq"};